import React from 'react';

import { Box, Chip, Paper, Typography } from '@mui/material';

import { palette, lightPalette, shape, shadows } from '@app/theme';
import { MarkdownContent } from '@components/ui/MarkdownContent';

import type { InvestmentThesisBannerProperties } from './InvestmentThesisBanner.types';


export const InvestmentThesisBanner: React.FC<InvestmentThesisBannerProperties> = ({
  summary,
  dataTest = 'investment-thesis-banner',
}) => {
  return (
    <Paper
      elevation={0}
      data-testid={dataTest}
      sx={{
        p: 3,
        borderRadius: `${shape.borderRadius}px`,
        backgroundColor: palette.primary.subtle,
        border: '1px solid',
        borderColor: lightPalette.border.default,
        borderLeft: `4px solid ${palette.primary.main}`,
        boxShadow: shadows.sm,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: 1.5,
          mb: 2,
        }}
      >
        <Typography
          sx={{
            fontSize: '0.6875rem',
            fontWeight: 600,
            letterSpacing: '0.08em',
            textTransform: 'uppercase',
            color: lightPalette.text.secondary,
          }}
        >
          Инвестиционный тезис
        </Typography>

        {summary.strategy_label && (
          <Chip
            data-testid={`${dataTest}_strategy`}
            label={summary.strategy_label}
            size='small'
            sx={{
              fontFamily: "'JetBrains Mono', monospace",
              fontSize: '0.75rem',
              fontWeight: 600,
              height: 26,
              color: palette.primary.main,
              backgroundColor: lightPalette.background.paper,
              border: `1.5px solid ${lightPalette.border.default}`,
              borderRadius: `${shape.borderRadius}px`,
              '& .MuiChip-label': { px: 1.25 },
            }}
          />
        )}
      </Box>

      <MarkdownContent variant='thesis' dataTest={`${dataTest}_thesis`}>
        {summary.investment_thesis}
      </MarkdownContent>
    </Paper>
  );
};
